import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/everyone_500.png'


const _withScopeId = n => (_pushScopeId("data-v-392e1543"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "family-group-page" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "page-title-icon"
}, null, -1))
const _hoisted_4 = { class: "with-subhead" }
const _hoisted_5 = { class: "subhead" }
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = {
  type: "button",
  id: "membersTab",
  class: "nav-link active",
  "data-bs-toggle": "tab",
  "data-bs-target": "#membersPane",
  role: "tab",
  "aria-controls": "membersPane",
  "aria-selected": "true"
}
const _hoisted_8 = {
  key: 0,
  class: "count"
}
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = {
  type: "button",
  id: "researchGroupsTab",
  class: "nav-link",
  "data-bs-toggle": "tab",
  "data-bs-target": "#researchGroupsPane",
  role: "tab",
  "aria-controls": "researchGroupsPane",
  "aria-selected": "true"
}
const _hoisted_11 = {
  key: 0,
  class: "count"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    id: "manageTab",
    class: "nav-link",
    "data-bs-toggle": "tab",
    "data-bs-target": "#managePane",
    role: "tab",
    "aria-controls": "managePane",
    "aria-selected": "false"
  }, " Manage ")
], -1))
const _hoisted_13 = { class: "tab-content content-area" }
const _hoisted_14 = {
  id: "membersPane",
  class: "tab-pane show active",
  role: "tabpanel",
  "aria-labelledby": "membersTab",
  tabindex: "0"
}
const _hoisted_15 = { class: "scope-area" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "area-header" }, " Common ancestors ", -1))
const _hoisted_17 = {
  key: 0,
  class: "members-area"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "area-header" }, " Group members ", -1))
const _hoisted_19 = {
  id: "researchGroupsPane",
  class: "tab-pane",
  role: "tabpanel",
  "aria-labelledby": "researchGroupsTab",
  tabindex: "0"
}
const _hoisted_20 = { class: "area-body" }
const _hoisted_21 = {
  id: "managePane",
  class: "tab-pane",
  role: "tabpanel",
  "aria-labelledby": "manageTab",
  tabindex: "0"
}

import { computed, onMounted, ref, watch } from 'vue'
import { usePageTitle } from '@/util/AppUtil'
import { ItemPermissions } from '@/gp/GroupAdminModel'
import { useFamilyGroupStore } from '@/gp/FamilyGroupStore'
import { useFamilyGroupMemberStore } from '@/gp/FamilyGroupMemberStore'
import { useDataGroupMemberStore } from '@/gp/DataGroupMemberStore'
import { useDataGroupStore } from '@/gp/DataGroupStore'
import { LoadMode } from '@/util/AsyncData'
import { useInitialTabRouting } from '@/util/InitialTabRouting'
import { useTabsTelemetry } from '@/util/TabTelemetry'
import { Tab } from 'bootstrap'
import UserLink from '@/manage/users/UserLink.vue'
import ResultIndicator from '@/util/ResultIndicator.vue'
import FamilyGroupScope from './FamilyGroupScope.vue'
import FamilyGroupMemberList from './FamilyGroupMemberList.vue'
import FamilyGroupSharedResearchGroups from './FamilyGroupSharedResearchGroups.vue'
import FamilyGroupManage from './FamilyGroupManage.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FamilyGroupPage',
  props: {
    familyGroupId: {}
  },
  emits: ["chooseMembers"],
  setup(__props: any, { emit }) {

const props = __props;





const tabsElemRef = ref<HTMLElement>()
const scopeLoadedRef = ref(false)
const scopeStepDismissedRef = ref(false)
const showSuggestedRef = ref(false)

const createSuccessAlertRef = ref<InstanceType<typeof ResultIndicator>>()
const scopeRef = ref<InstanceType<typeof FamilyGroupScope>>()
const memberListRef = ref<InstanceType<typeof FamilyGroupMemberList>>()

const familyGroupStore = useFamilyGroupStore()
const familyGroupMemberStore = useFamilyGroupMemberStore()
const dataGroupMemberStore = useDataGroupMemberStore()
const dataGroupStore = useDataGroupStore()

const familyGroupRef = computed(() => familyGroupStore.getAsyncGroup(props.familyGroupId, LoadMode.EnsureLoaded)?.data)
const permissionsRef = computed(() => familyGroupStore.getAsyncPermissions(props.familyGroupId, LoadMode.EnsureLoaded)?.data || ItemPermissions.None)
const isOwnerRef = computed(() => (permissionsRef.value & ItemPermissions.Owner) > 0)
const hasNameRef = computed(() => !!familyGroupRef.value?.name)
const title = computed(() => familyGroupRef.value?.name ?? "New group")
const membersRef = computed(() => familyGroupMemberStore.getMembersForFamilyGroups([props.familyGroupId], LoadMode.EnsureLoaded))
const sharedDataGroupsRef = computed(() => {
  const sharedDataGroupIds = dataGroupMemberStore.getMembersForFamilyGroups([props.familyGroupId], LoadMode.EnsureLoaded)
    .map(m => m.dataGroupId)
  return dataGroupStore.getLoadedGroupList(sharedDataGroupIds) // loaded with members
})
const sharedResearchGroupsRef = computed(() => sharedDataGroupsRef.value.filter(dg => !dg.isProfile))
const sharedProfilesRef = computed(() => sharedDataGroupsRef.value.filter(dg => dg.isProfile))
const showScopeStepRef = computed(() => !scopeStepDismissedRef.value && !familyGroupRef.value?.scopeFamilyId && isOwnerRef.value && sharedProfilesRef.value.length <= 1) // owner only
  
usePageTitle("Group", () => familyGroupRef.value?.name)
useInitialTabRouting('membersTab')
useTabsTelemetry(tabsElemRef)

watch(() => props.familyGroupId, () => scopeLoadedRef.value = false)

onMounted(() => {
  scopeStepDismissedRef.value = false // reset on page load

  const createdDate = familyGroupRef.value?.createdDate
  if (createdDate && Math.abs(createdDate.diffNow('seconds').seconds) < 30) {
    createSuccessAlertRef.value?.show()
  }
})

watch(familyGroupRef, () => {
  showSuggestedRef.value = !!familyGroupRef.value?.scopeFamilyId
})

function onChooseMembers() {
  new Tab(document.getElementById("membersTab")!).show()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", {
        class: _normalizeClass(["page-title-text-area", { 'has-name': hasNameRef.value }])
      }, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(title.value), 1),
        _createElementVNode("p", _hoisted_5, [
          _createTextVNode(" Group managed by "),
          _createVNode(UserLink, {
            "user-id": familyGroupRef.value?.ownerId,
            dimmed: ""
          }, null, 8, ["user-id"])
        ])
      ], 2)
    ]),
    _createVNode(ResultIndicator, {
      ref_key: "createSuccessAlertRef",
      ref: createSuccessAlertRef,
      "alert-type": "success"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" New group created. ")
      ]),
      _: 1
    }, 512),
    _createElementVNode("div", null, [
      _createElementVNode("ul", {
        ref_key: "tabsElemRef",
        ref: tabsElemRef,
        class: "nav nav-pills",
        role: "tablist"
      }, [
        _createElementVNode("li", _hoisted_6, [
          _createElementVNode("button", _hoisted_7, [
            _createTextVNode(" People "),
            (membersRef.value.length > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(membersRef.value.length), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("li", _hoisted_9, [
          _createElementVNode("button", _hoisted_10, [
            _createTextVNode(" Shared trees "),
            (membersRef.value.length > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(sharedResearchGroupsRef.value.length), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _hoisted_12
      ], 512)
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("section", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createVNode(FamilyGroupScope, {
            ref_key: "scopeRef",
            ref: scopeRef,
            "family-group-id": _ctx.familyGroupId,
            "show-step": showScopeStepRef.value,
            onLoaded: _cache[0] || (_cache[0] = ($event: any) => (scopeLoadedRef.value = true)),
            onStepDismissed: _cache[1] || (_cache[1] = ($event: any) => (scopeStepDismissedRef.value = true))
          }, null, 8, ["family-group-id", "show-step"])
        ]),
        (scopeLoadedRef.value && !showScopeStepRef.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _hoisted_18,
              _createVNode(FamilyGroupMemberList, {
                ref_key: "memberListRef",
                ref: memberListRef,
                "family-group-id": props.familyGroupId,
                "disable-list-actions": showScopeStepRef.value
              }, null, 8, ["family-group-id", "disable-list-actions"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("section", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createVNode(FamilyGroupSharedResearchGroups, {
            "family-group-id": _ctx.familyGroupId,
            onChooseMembers: onChooseMembers
          }, null, 8, ["family-group-id"])
        ])
      ]),
      _createElementVNode("section", _hoisted_21, [
        _createVNode(FamilyGroupManage, { "family-group-id": _ctx.familyGroupId }, null, 8, ["family-group-id"])
      ])
    ])
  ]))
}
}

})